import { getUserConfig } from '../api/authority';
import { setIsClaimedDailyDrops, setChatParameter, setUseSuggestion } from '../store/userSlice';
import { IsVisitor } from '../util/author';
import { getLocalStorage } from '../util/storage';
import type { AppDispatch } from '../store';

export async function initUserConfig(dispatch: AppDispatch) {
  const userInfoStr = getLocalStorage('userInfo');
  if (!userInfoStr) return;
  if (IsVisitor()) return;

  const cfg = await getUserConfig();
  const useSuggestion = cfg?.config?.useSuggestion;
  if (typeof useSuggestion === 'boolean') {
    dispatch(setUseSuggestion(useSuggestion));
  }

  const chatParameter = cfg?.chatParameter;

  if (typeof chatParameter === 'string') {
    dispatch(setChatParameter(chatParameter));
  }else {
    dispatch(setChatParameter('empty'));
  }

  if (typeof cfg?.isClaimedDailyDrops === 'boolean') {
    dispatch(setIsClaimedDailyDrops(cfg.isClaimedDailyDrops));
  }
}

